<template lang="pug">
page-template(title="Eventos")
  .d-flex.justify-center.pb-4(v-if="categories.length")
    v-chip-group(
      v-model="categoriesSelecteds",
      active-class="primary white--text",
      column,
      multiple,
      center
    )
      v-chip.rounded-pill.py-4.text-body-2(
        v-for="({ text, value }, i) in categories",
        :value="value",
        :key="i"
      )
        span.font-weight-medium {{ text }}

  grid-container.mt-md-4.pb-10(cols="auto", gap="0", gap-md="80px")
    div
      template(v-if="!loading")
        template(v-if="items.length")
          grid-list.justify-start(
            col-width-xs="auto",
            col-width-sm="calc(50% - 16px)",
            col-width-md="238px",
            col-width-lg="246px",
            col-width-xl="330px"
          )
            template(v-for="(item, i) in items")
              gallery-card(:key="i", v-bind="item")
          v-pagination.mt-6(
            v-if="items.length && pagesLength",
            v-model="page",
            :length="pagesLength",
            :total-visible="pagesTotalVisible",
            flat
          )
        .d-flex.justify-center(v-else)
          v-alert.mx-auto(type="info", color="secondary") Nenhuma galeria encontrada.
      .py-10.d-flex.justify-center(v-else)
        v-progress-circular(size="50", color="primary", indeterminate)
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import CustomTitle from "../../others/CustomTitle.vue";
import GalleryCard from "../../cards/Gallery.vue";
import { formatToURL, getYoutubeCode } from "../../utils";

export default {
  data: () => ({
    loading: true,
    itemsPerPage: 16,
    pagesTotalVisible: 6,
    totalItems: 0,
  }),
  beforeCreate() {
    this.$rest("categories").get({
      params: {
        modulesFieldsId: 54,
      },
    });
  },
  created() {
    this.getList();
  },
  computed: {
    items() {
      return this.$rest("galleries").list.map(({ id, img, title, video }) => ({
        img: img
          ? this.files + "/" + img + "?resize=1&w=300"
          : video
          ? `https://img.youtube.com/vi/${getYoutubeCode(video)}/sddefault.jpg`
          : "",
        title,
        to: `/galeria/${formatToURL(`${title}-${id}`)}`,
      }));
    },
    categories() {
      return this.$rest("categories").list.map(({ id, title }) => ({
        text: title,
        value: id,
      }));
    },
    query() {
      return this.$route.query;
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    page: {
      get() {
        const p = this.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.p = v;
        else delete query.p;

        this.$router.push({ path: "/galeria", query });
      },
    },
    categoriesSelecteds: {
      get() {
        return this.query.c
          ? this.query.c.split(",").map((v) => parseInt(v))
          : [];
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.c = v.join(",");
        else delete query.c;

        this.$router.push({ query });
      },
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        returnTotalItems: 1,
        itemsPerPage: this.itemsPerPage,
      };

      if (this.page) params.page = this.page;
      if (this.query.c) params.category = this.query.c;

      this.$rest("galleries").get({
        params,
        keepCache: true,
        save: (state, { totalItems, list }) => {
          this.totalItems = totalItems;
          state.list = list;
          this.loading = false;
        },
      });
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  components: {
    PageTemplate,
    CustomTitle,
    GalleryCard,
  },
};
</script>
